module.exports = __webpack_public_path__ + "static/media/stars.9289faaa.svg";